import gql from 'graphql-tag'

export const MUTATION_UNIT = gql`
  mutation UpdateUnit($data: UnitUpdateInput!) {
    updateUnit(data: $data) {
      _id
    }
  }
`

export const MUTATION_UNITS_ORDER = gql`
  mutation UpdateTagsUnits($data: [UnitTagsInput!]!) {
    updateTagsUnits(data: $data)
  }
`

export const GET_UNIT_GROUPS = gql`
  query GetUnitGroups($page: Int, $pageSize: Int, $sortDirection: [SortDirection], $sort: [String], $search: String) {
    unitGroups(page: $page, pageSize: $pageSize, sortDirection: $sortDirection, sort: $sort, search: $search) {
      records
      page
      unit_groups {
        _id
        name
        units {
          _id
          id_erp
          name
        }
      }
    }
  }
`

export const DELETE_UNIT_GROUP = gql`
  mutation DeleteUnitGroups($_id: ID!) {
    deleteUnitGroups(_id: $_id)
  }
`

export const UPSERT_UNIT_GROUPS = gql`
  mutation UpsertUnitGroups($data: UnitGroupInput!) {
    upsertUnitGroups(data: $data) {
      _id
      name
      units {
        _id
        id_erp
        name
        address
        mobile
      }
    }
  }
`

export const QUERY_UNITS = gql`
  query Units {
    units: allUnits {
      _id
      id_erp
      name
      cnpj
      address
      contact
      mobile
      pdv_token
      retailer_flag_id
      ecommerce_v2_active
      active
      tags {
        name
        color
      }
      location {
        type
        coordinates
      }
      address_components {
        postal_code
        street
        neighborhood
        number
        complement
        city
        city_name
        federative_unit
      }
      office_hours {
        monday {
          start
          finish
        }
        tuesday {
          start
          finish
        }
        wednesday {
          start
          finish
        }
        thursday {
          start
          finish
        }
        friday {
          start
          finish
        }
        saturday {
          start
          finish
        }
        sunday {
          start
          finish
        }
        holidays {
          start
          finish
        }
      }
      ecommerce_partner {
        partner_type
        partner_unit_id
      }
    }
  }
`

export const QUERY_GET_UNIT_FLAGS = gql`
  query RetailerFlags {
    retailerFlags {
      default
      id
      logoSelectorRetailerFlag
      name
    }
  }
`
